import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { $$, IJNativeEvent, JNative, JNativeStatic } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ApplicationInformationService } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { BlobDownloader } from "@seriously-rad/seriouslyrad-framework-core/Server/BlobDownloader";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { ApplicationDataService } from "@seriously-rad/seriouslyrad-framework-core/Ui/ApplicationDataService";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { IMessageDialog, MessageDialog, MessageDialogPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { NAMESPACE } from "./_Namespace";

export type ReportDownloadDialogPropertyValues =
    MessageDialogPropertyValues
    & {
    };

export type ReportDownloadDialogProperties = {
    [name in keyof ReportDownloadDialogPropertyValues]: Property<ReportDownloadDialogPropertyValues[name]>
};

export interface IReportDownloadDialog extends IMessageDialog, ReportDownloadDialogProperties
{
}

export class ReportDownloadDialog extends MessageDialog implements IReportDownloadDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ReportDownloadDialog";
    public static override className = "ReportDownloadDialog";

    // #region Constructor

    static {
        $$(document).on("click", ".rad-control-dialog-report-download .download-link", (evt: IJNativeEvent) =>
        {
            const
                authenticationData = ServiceManager.getOptional(ApplicationDataService)?.authenticationData.get();

            if (authenticationData)
            {
                switch (authenticationData.scheme)
                {
                    case "Bearer":
                        {
                            Assert.isNotNullOrUndefined(authenticationData.accessToken, "authenticationData.accessToken");

                            evt.preventDefault();

                            const
                                $$currentTarget = $$(evt.currentTarget),
                                fileUrl = $$currentTarget.attr("href"),
                                reportDownloadDialog = $$currentTarget.closest(".rad-control-dialog-report-download").radControl();

                            if (fileUrl)
                            {
                                new
                                    BlobDownloader({
                                        headers: {
                                            "Authorization": `${authenticationData.scheme} ${authenticationData.token}`
                                        }
                                    })
                                    .downloadAsync(fileUrl, reportDownloadDialog.$$downloadLink);
                            }

                            break;
                        }
                }
            }
        });
    }

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ReportDownloadDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                buttonStyle: ButtonStyleEnum.okOnly,
                text: "Please use the link below to download the report:",
                title: "Download Report",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected $$downloadLink?: JNative<HTMLElement>;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ReportDownloadDialogPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-dialog-report-download");
    }

    // #endregion

    // #region Overrides

    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.$$downloadLink =
            JNativeStatic.create$$({
                nodeName: "a",
                attributes: {
                    style: "display: none"
                }
            }).appendTo($$element);

        return $$element;
    }
    public override openAsync(userReportId: string)
    {
        this._textElementRef.current.empty();

        this._textElementRef.current.append(
            $$(
                StringHelper.format(
                    "<a class=\"download-link\" target=\"new\" href=\"{0}api/reportview/getreport/{1}\">Download Report</a>",
                    ServiceManager.getRequired(ApplicationInformationService).serverVirtualDirectory,
                    userReportId
                )
            )
        );

        this._textElementRef.current.show();

        return super.openAsync();
    }

    // #endregion

    // #endregion
}

